/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_Transfer_SubmitInputs */

const cs_properties_bulk_transfer_submit = /** @type {(inputs: Properties_Bulk_Transfer_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převést`)
};

const en_properties_bulk_transfer_submit = /** @type {(inputs: Properties_Bulk_Transfer_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer`)
};

/**
* | output |
* | --- |
* | "Transfer" |
*
* @param {Properties_Bulk_Transfer_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer_submit = /** @type {((inputs?: Properties_Bulk_Transfer_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_Transfer_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer_submit(inputs)
	return cs_properties_bulk_transfer_submit(inputs)
});